import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import routes from '../../router/routes'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

const styles = {
    list: {
        width: 250,
    },
}

class Component extends React.Component {
    getDrawerItems() {
        let drawerItems = { ...routes }
        let userPermissions = this.props.appStore.userPermissions
        let menuItems = Object.entries(drawerItems).filter(
            (item) =>
                item.length === 2 &&
                item[1].drawerOrder &&
                Number.isInteger(item[1].drawerOrder)
        )

        let allowedMenuItems = []
        if (userPermissions) {
            if (!userPermissions.some(x=>x === "orders")) 
                userPermissions.push("orders");
            for (let i = 0; i < menuItems.length; i++) {
                let menuItem = menuItems[i]
                let appIdentifier = menuItem[0]
                if (userPermissions.find(x => x === appIdentifier)) {
                    allowedMenuItems.push(menuItem);
                }
            }
        }
        return allowedMenuItems.map((x) => x[1]).sort((a, b) => a.drawerOrder - b.drawerOrder);
    }


    render() {
        const { classes, history } = this.props
        let drawerItems = this.getDrawerItems()
        const list = (
            <div className={classes.list}>
                <List>
                    {drawerItems.map((route, index) => (
                        <ListItem
                            button
                            key={index}
                            onClick={() => history.push(route.path)}
                        >
                            {/*<ListItemIcon>{index % 2 === 0 ? <InboxIcon/> : <MailIcon/>}</ListItemIcon>*/}

                            <ListItemIcon>{route.icon}</ListItemIcon>
                            <ListItemText primary={route.title} />
                        </ListItem>
                    ))}
                </List>
            </div>
        )

        return (
            <div>
                <Drawer
                    open={this.props.toggleDrawerOpened}
                    onClose={this.props.toggleDrawer(false)}
                >
                    <div
                        tabIndex={0}
                        role="button"
                        onClick={this.props.toggleDrawer(false)}
                        onKeyDown={this.props.toggleDrawer(false)}
                    >
                        {list}
                    </div>
                </Drawer>
            </div>
        )
    }
}

Component.propTypes = {
    classes: PropTypes.object.isRequired,
}
const mapDispatchToProps = {}
const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(Component)))
